(function ($) {

  const initializeBlock = function ($block) {
    console.log('here')
    function matchHeightFire() {
      $('.stat-boxes .stat-box .stat-box__icon').matchHeight( {property: 'min-height'} );
      $('.stat-boxes .stat-box .stat-box__body').matchHeight( {property: 'min-height'} );
    }
    matchHeightFire()

    $( window ).bind('resize orientationchange', function() {
      matchHeightFire();
    });

    setTimeout(function() {
      matchHeightFire();
    }, 1000)
  }

  $(document).ready(function () {
    $('.block--list-stats-box').each(function () {
      initializeBlock($(this));
    })
  })

  if (window.acf) {
    window.acf.addAction('render_block_preview/type=block--list-stats-box', initializeBlock);
  }

})(jQuery);